import React, { Fragment, Component } from "react"

import type { Evidence } from "../../types/types"
import AddEvidenceButton from "./AddEvidenceButton"
import ContentLoaderLines from "./content-loading/ContentLoaderLines"
import EvidenceLinkForm from "./EvidenceLinkForm"
import EvidenceListItem from "./EvidenceListItem"

type Props = {
    roleId: string,
    evidence: Evidence,
    isFetching: boolean,
    isExpanded: boolean,
    toggleEvidence: string => void
}

type State = {
    isAdding: boolean
}

class EvidenceExpandableBlock extends Component<Props, State> {
    state = {
        isAdding: false
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (
            nextProps.evidence.length > this.props.evidence.length
        ) {
            this.setState({
                isAdding: false
            })
        }
    }

    showEvidenceLinkForm = () => {
        this.setState({
            isAdding: !this.state.isAdding
        })
    }

    render() {
        const { evidence, isExpanded, toggleEvidence, roleId } = this.props

        const { isAdding } = this.state

        let elementsToShow

        if (isExpanded && evidence) {
            elementsToShow = [
                <ContentLoaderLines
                    isFetching={evidence.isFetchingList}
                    minLines={1}
                    maxLines={2}
                    key="contentLoaderLines"
                >
                    {evidence.items
                        .filter(item => item.saveStatus !== "DELETE")
                        .map((item, index) => (
                            <EvidenceListItem
                                key={item.id || index}
                                item={item}
                                roleID={roleId}
                                isEditMode={true}
                            />
                        ))}
                </ContentLoaderLines>
            ]

            if (isAdding) {
                elementsToShow.push(
                    <EvidenceLinkForm key="link-form" roleID={roleId} />
                )
            } else if (!evidence.isFetchingList) {
                elementsToShow.push(
                    <AddEvidenceButton
                        key="add-evidence-button"
                        onClick={this.showEvidenceLinkForm}
                    />
                )
            }
        }

        return (
            <Fragment>
                {elementsToShow}
                <button
                    className={`evidence-expand-button ${
                        isExpanded ? "evidence-block--expanded" : ""
                    }`}
                    onClick={toggleEvidence(roleId)}
                    data-cy="evidenceExpandButton"
                >
                    Evidence{" "}
                    <span
                        className={`fa fa-chevron-${
                            isExpanded ? "up" : "down"
                        } evidence-block-chevron`}
                    />
                </button>
            </Fragment>
        )
    }
}

export default EvidenceExpandableBlock
